

















































import { Vue, Component } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import {
  VcClaimSetStatusDto,
  VcClaimSummaryLightDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import util from "@/lib/util";
import ClaimViewBaseComponent from "./ClaimViewBaseComponent";

@Component({})
export default class ChangeStatus extends ClaimViewBaseComponent {
  inputModel = new VcClaimSetStatusDto();
  statuses: any[] = [];

  async created() {
    let res = await this.$appsvs.vcpOnlineOkStaff.retrieveVcClaimForStaff(this.vcClaimNumber);
    abp.log.debug({'change-status.vue: res.validWorkItemStatuses':res.validWorkItemStatuses});

    if (!!res.validWorkItemStatuses) {
      for (var i = 0; i < res.validWorkItemStatuses.length; i++) {
        for (var j = 0; j < util.abp.constant.claimStatus.values.length; j++) {
          if (res.validWorkItemStatuses[i] == util.abp.constant.claimStatus.values[j].value) {
            this.statuses.push(util.abp.constant.claimStatus.values[j]);
          }
        }
      }
    } 
  }
  //this.statuses = this.getConstValuesSorted(this.statuses);

  onClose() {
    this.$router.push({ name: "ClaimSummary" });
    this.inputModel = new VcClaimSetStatusDto();
  }

  onSave() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.inputModel.claimNumber = this.$route.params.claimNumber;
        this.$appsvs.vcpOnlineOkStaff
          .setVcClaimStatus(this.inputModel)
          .then((res: VcClaimSummaryLightDto) => {
            this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
            this.onClose();
          });
      }
    });
  }
}
